import '../../application/bundles/datatables/js/datatables';



// WEBPACK FOOTER //
// resources/assets/scripts/autoload/_application.js